import posthog from 'posthog-js'

// PostHog is initialized in routes/__root.tsx. Flags arrive asynchronously
// after init/identify, so flag reads wait for the first onFeatureFlags
// callback, bounded by a timeout so a blocked network can never hang the app.
const FLAGS_TIMEOUT_MS = 5000

let flagsReady: Promise<void> | undefined
const waitForFlags = () => {
  if (!flagsReady) {
    flagsReady = new Promise<void>((resolve) => {
      try {
        posthog.onFeatureFlags(() => resolve())
      } catch {
        resolve()
      }
      setTimeout(resolve, FLAGS_TIMEOUT_MS)
    })
  }
  return flagsReady
}

export const booleanFlag = async (flag: string) => {
  await waitForFlags()
  return posthog.isFeatureEnabled(flag) === true
}

export const stringFlag = async (flag: string, defaultValue: string) => {
  await waitForFlags()
  const payload = posthog.getFeatureFlagResult(flag)
  if (typeof payload === 'string') {
    return payload
  }
  const variant = posthog.getFeatureFlag(flag)
  return typeof variant === 'string' ? variant : defaultValue
}

export const numberFlag = async (flag: string, defaultValue: number) => {
  await waitForFlags()
  const payload = posthog.getFeatureFlagResult(flag)
  return typeof payload === 'number' ? payload : defaultValue
}

export const jsonFlag = async <T>(flag: string, defaultValue: T): Promise<T> => {
  await waitForFlags()
  const payload = posthog.getFeatureFlagResult(flag)
  return payload !== undefined && payload !== null ? (payload as T) : defaultValue
}

export const useFeatureFlags = () => {}
